module.exports = __webpack_public_path__ + "static/media/play-btn.4e7953ba.svg";